<template>
  <v-dialog v-model="rootStore.messageDialogShow" persistent class="msg-dialog">
    <v-card class="modal-confirm">
      <v-card-title v-if="rootStore.messageDialogTitle" v-html="rootStore.messageDialogTitle" class="modal-header"></v-card-title>
      <v-card-text v-html="rootStore.messageDialogMessage" class="modal-body text-center"></v-card-text>
      <v-card-actions class="modal-footer">
		    <button type="button" class="btn okay" @click="clickButton()">{{ rootStore.messageDialogButtonText }}</button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useRootStore } from '@/stores/useRootStore';

const rootStore = useRootStore();

const clickButton = () => {
  if (rootStore.messageDialogClickListener) rootStore.messageDialogClickListener();
  rootStore.resetMessageDialog();
}

</script>

<style scoped>
  .msg-dialog{
    font-size:var(--hecto-font-32);
  }
  .v-dialog .v-overlay__content > .v-card, .v-dialog .v-overlay__content > .v-sheet{
    border-radius:3.2rem; 
    overflow: hidden; 
    box-shadow: 0 0 2rem 0 rgba(0,0,0,.25);
  }
  .v-dialog .v-overlay__content > .v-card > .v-card-title{
    justify-content: center;
    padding:6.5rem 9rem 3rem;
    font-size:var(--hecto-font-40);
    font-weight: 600;
    text-align:center;
    color:var(--hecto-black);
    border:0;
    letter-spacing: -0.05em;
    line-height: 1.3;
  }
  .v-dialog .v-overlay__content > .v-card > .v-card-text{
    padding:7rem 2.4rem 0;
    font-size:var(--hecto-font-28); 
    color:var(--hecto-black);
    text-align:center; 
    word-break: keep-all;
    opacity:1;
  }
  .v-dialog .v-overlay__content > .v-card > .v-card-title+.v-card-text{
    padding-top:0;
  }
  .v-dialog .modal-confirm .modal-footer{
    height:auto; 
    padding:4rem 3.8rem 4.8rem; 
    border:0;
  }
  .v-dialog .modal-confirm .modal-footer .btn{
    height:9.4rem;
    margin:0 auto; 
    padding:0; 
    border-radius:1.6rem;
    font-weight:500;
    font-size:var(--hecto-font-32);
  }
  .v-dialog .modal-confirm .modal-footer .btn+.btn{
    margin-left:2rem;
  }
  .v-dialog .modal-confirm .modal-footer .btn.okay{
    width:34rem;
    color:var(--hecto-white, #fff);
    background-color:var(--hecto-primary, #305ae4);
  }
</style>
